import React from 'react';

const LPContentSection = ({ title, children, bgColor = 'bg-white', textColor = 'text-gray-800' }) => {
  return (
    <section className={`${bgColor} ${textColor} pt-4 pb-6 md:pt-4 md:pb-6`} id={title?.toLowerCase().replace(/\s+/g, '-')}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 ">
        {title && (
          <h2 className="text-2xl xl:text-4xl 2xl:text-5xl font-semibold text-center mb-1 md:mb-4">
            {title}
          </h2>
        )}
        <div className="prose lg:prose-xl max-w-none">
          {/* The 'prose' class from @tailwindcss/typography can be useful for styling blocks of text.
            Install it with: npm install -D @tailwindcss/typography
            And add it to your tailwind.config.js plugins: require('@tailwindcss/typography'),
          */}
          {children}
        </div>
      </div>
    </section>
  );
};

export default LPContentSection;